export const TOOL_NAME = 'pdfme (https://github.com/hand-dot/pdfme)' as const;
